import { render, staticRenderFns } from "./ModalNoteReport.vue?vue&type=template&id=35eb070a&scoped=true&lang=pug&"
import script from "./ModalNoteReport.vue?vue&type=script&lang=ts&"
export * from "./ModalNoteReport.vue?vue&type=script&lang=ts&"
import style0 from "./ModalNoteReport.vue?vue&type=style&index=0&id=35eb070a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eb070a",
  null
  
)

export default component.exports